import { Component, OnInit, ViewChild } from '@angular/core';
import { MatExpansionPanel } from '@angular/material/expansion';
import { AuthenticationService } from 'src/app/core/services/Authentication/authentication.service';
import { MyAccountService } from 'src/app/core/services/my-account/my-account.service';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import * as moment from 'moment-timezone';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.css']
})
export class NotificationsComponent implements OnInit {
  @ViewChild(MatExpansionPanel) panel?: MatExpansionPanel;
  @ViewChild(MatPaginator) paginator?: MatPaginator;

  panelOpenState = false;
  userId: number;
  notifications: any[];
  filteredNotifications: any[];
  pagedNotifications: any[] = [];

  pageSize = 5;
  pageSizeOptions: number[] = [5, 10, 25, 50];
  searchText: '';

  constructor(
    private accountService: MyAccountService,
    private authenticationService: AuthenticationService,
  ) { }

  ngOnInit(): void {
    this.authenticationService.checkUserAuthenticated()
      .subscribe(
        (res: any) => {
          this.userId = res.userId;
          this.getNotifications()
        }
      );
  }

  openNotifications() {
    this.panelOpenState = true;
    this.getNotifications();

  }

  pacificTimezone(date: any) {

    const time = moment(date).tz("America/Los_Angeles").format('Z')
    var pacificTZ = time
    return pacificTZ;

  }

  userTimezoneName(date: any) {

    const time = moment(date).tz("America/Los_Angeles").format('Z')
    var pacificTZ = date + time
    var newDate = new Date(pacificTZ).toString();
    var zone = moment.tz.guess();
    var timezoneName = moment(newDate).tz(zone).format('z')
    return timezoneName;
  }

  getNotifications() {
    const currentDate = new Date();
    const threeMonthsAgo = new Date();
    threeMonthsAgo.setMonth(currentDate.getMonth() - 3);


    this.accountService.getNotifications(this.userId)
      .subscribe(
        (res) => {

          this.notifications = res.notifications.reverse();
              this.notifications = this.notifications.filter((notification) => {
            const notificationDate = new Date(notification.pDate);
            return notificationDate >= threeMonthsAgo;
          });
          this.filteredNotifications = [...this.notifications];
          this.updatePagedNotifications();
        }
      );
  }

  searchNotifications(searchText: string) {
    if (searchText.trim() === '') {
      this.filteredNotifications = [...this.notifications];
    } else {
      this.filteredNotifications = this.notifications.filter(notification =>
        notification.title.toLowerCase().includes(searchText.toLowerCase())
      );
    }
    this.updatePagedNotifications();
  }

  clearSearchInput(inputElement: HTMLInputElement) {
    inputElement.value = '';
    this.searchNotifications('');
  }

  updatePagedNotifications() {
    const startIndex = this.paginator?.pageIndex * this.paginator?.pageSize;
    const endIndex = startIndex + this.paginator?.pageSize;
    this.pagedNotifications = this.filteredNotifications.slice(startIndex, endIndex);
  }

  onPageChange(event: PageEvent) {
    const startIndex = event.pageIndex * event.pageSize;
    const endIndex = startIndex + event.pageSize;
    this.pagedNotifications = this.filteredNotifications.slice(startIndex, endIndex);
  }
}
